import React, { useState } from "react";
import MlbPitcherProjections from "./MlbPitcherProjections";
import MlbBattersProjections from "./MlbBattersProjections";

export default function MlbPositionalProjections() {
  const [tab, setTab] = useState("pitchers"); // "pitchers" | "batters"

  const outerClass =
    "min-h-screen bg-slate-100 text-slate-900 " +
    "dark:bg-slate-950 dark:text-slate-100";

  const pillWrap =
    "inline-flex items-center gap-1 rounded-xl p-1 border " +
    "bg-white border-slate-200 shadow-inner " +
    "dark:bg-slate-900/80 dark:border-slate-700";

  const pillBtn = (active) =>
    "px-3 py-1.5 rounded-lg text-sm inline-flex items-center gap-2 transition " +
    (active
      ? "bg-sky-500 text-slate-950 shadow font-semibold"
      : "text-slate-700 hover:text-slate-900 hover:bg-slate-100 " +
        "dark:text-slate-200 dark:hover:text-white dark:hover:bg-slate-800/60");

  return (
    <div className={outerClass}>
      <div className="mx-auto w-full max-w-screen-2xl px-3 sm:px-4 md:px-6 py-6">
        {/* Header */}
        <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between mb-4">
          <div className="flex items-baseline gap-3 flex-wrap">
            <h1 className="text-2xl md:text-3xl font-extrabold mb-0.5">
              MLB — Positional Projections
            </h1>

            <div className={pillWrap}>
              <button
                type="button"
                className={pillBtn(tab === "pitchers")}
                onClick={() => setTab("pitchers")}
              >
                Pitchers
              </button>
              <button
                type="button"
                className={pillBtn(tab === "batters")}
                onClick={() => setTab("batters")}
              >
                Batters
              </button>
            </div>
          </div>
        </div>

        {/* Render selected page */}
        {tab === "pitchers" ? <MlbPitcherProjections /> : <MlbBattersProjections />}
      </div>
    </div>
  );
}
